import {ValueListener} from "./interfaces";
import { Observable } from 'rxjs/Observable';
import { EventSource } from '../eventSite/eventSource';
import 'rxjs/add/operator/map';

export interface ProcessedAclRole {
    readonly isAdmin: boolean;
    readonly isOwner: boolean;
    readonly isMember: boolean;
    readonly isCrasher: boolean;
}

const compute = role => {
    const isOwner = role === "owner";
    const isAdmin = role === "admin" || isOwner;
    const isMember = role != "crasher"; // Owner + Admin are considered Members
    const isCrasher = role === "crasher";
    return {isOwner, isAdmin, isMember, isCrasher};
}

export const observeProcessedEventAclRole = (eventDataSource: any, listener: ValueListener<ProcessedAclRole>) => {

    listener = eventDataSource.wrapListener(listener);
    var role;

    var onUpdate = function () {
        listener.onValue(compute(role));
    };

    eventDataSource.observeEventAclRole(function (r) {
        role = r;
        onUpdate();
    });
};

export const observeProcessedEventAclRole$ = (eventSource: EventSource): Observable<ProcessedAclRole> => {
    return eventSource.observeEventAclRole().map(role => compute(role));
}
